import { showGrade } from "../../../utils/textUtils";

const GradeIncreasePreviewModal = ({ students, onConfirm, onCancel }) => {
  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(14, 20, 27, 0.45)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
    },
    modalContent: {
      backgroundColor: "#fff",
      borderRadius: "20px",
      boxShadow: "0 30px 80px rgba(14,20,27,.3)",
      width: "90vw",
      maxWidth: "600px",
      maxHeight: "80vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    modalHeader: {
      padding: "22px 24px 16px",
      borderBottom: "1px solid #E6EDEC",
    },
    title: {
      fontSize: "1.08rem",
      fontWeight: 800,
      color: "#0E141B",
      marginBottom: "5px",
    },
    subtitle: {
      fontSize: "0.84rem",
      fontWeight: 600,
      color: "#7A8490",
    },
    studentListContainer: {
      flex: 1,
      overflowY: "auto",
      padding: "20px",
      maxHeight: "50vh",
    },
    studentRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 6px",
      borderBottom: "1px solid #E6EDEC",
    },
    studentName: {
      fontWeight: 700,
      fontSize: "0.92rem",
      color: "#0E141B",
    },
    gradeTransition: {
      fontSize: "0.88rem",
      fontWeight: 700,
      color: "#3A434E",
      fontVariantNumeric: "tabular-nums",
    },
    modalFooter: {
      padding: "16px 24px 20px",
      borderTop: "1px solid #E6EDEC",
      display: "flex",
      gap: "10px",
      justifyContent: "flex-end",
    },
    confirmButton: {
      backgroundColor: "#0E141B",
      color: "#fff",
      border: "none",
      padding: "9px 22px",
      cursor: "pointer",
      borderRadius: "999px",
      fontSize: "0.86rem",
      fontWeight: 700,
      fontFamily: "inherit",
    },
    cancelButton: {
      backgroundColor: "#F4F8F7",
      color: "#3A434E",
      border: "none",
      padding: "9px 22px",
      cursor: "pointer",
      borderRadius: "999px",
      fontSize: "0.86rem",
      fontWeight: 700,
      fontFamily: "inherit",
    },
  };

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <div style={styles.title}>학년 일괄 증가 미리보기</div>
          <div style={styles.subtitle}>총 {students.length}명의 학생</div>
        </div>

        <div style={styles.studentListContainer}>
          {students.map((student, index) => (
            <div
              key={student.id}
              style={{
                ...styles.studentRow,
                backgroundColor: "#FFF",
              }}
            >
              <span style={styles.studentName}>{student.name}</span>
              <span style={styles.gradeTransition}>
                {showGrade(student.grade)} → {showGrade(student.grade + 1)}
              </span>
            </div>
          ))}
        </div>

        <div style={styles.modalFooter}>
          <button style={styles.cancelButton} onClick={onCancel}>
            취소
          </button>
          <button style={styles.confirmButton} onClick={onConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default GradeIncreasePreviewModal;
